import axios from '@/util/axios'
import { NEW_API_CONFIG } from '@/util/constants'
import store from '@/store'
import { handleApiError as handleError } from '@/util/axios_common'

/**
 * ナレッジカテゴリ一覧API
 * @param  {} params={}
 */
export const listCategories = (params = {}) => {
  const token = store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = {
    ...params,
    token: token,
    organization_id: organizationId
  }

  const newAxios = axios.create(NEW_API_CONFIG)
  return newAxios.post('/KN/001', r).catch(handleError)
}

/**
 * 最新ナレッジ一覧API
 * @param  {} params={}
 */
export const list = (params = {}) => {
  const token = store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = {
    ...params,
    token: token,
    organization_id: organizationId
  }

  const newAxios = axios.create(NEW_API_CONFIG)
  return newAxios.post('/KN/002', r).catch(handleError)
}

/**
 * 最新ナレッジ詳細API
 * @param  {} params={}
 */
export const detail = (params = {}) => {
  const token = store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = {
    ...params,
    token: token,
    organization_id: organizationId
  }

  const newAxios = axios.create(NEW_API_CONFIG)
  return newAxios.post('/KN/003', r).catch(handleError)
}

/**
 * 最新ナレッジキーワード検索数取得API
 * @param  {} params={}
 */
export const searchCount = (params = {}) => {
  const token = store.state.auth.token
  const organizationId = store.state.profile.organization_id
  
  const r = {
    ...params,
    token: token,
    organization_id: organizationId
  }

  const newAxios = axios.create(NEW_API_CONFIG)
  return newAxios.post('/KN/004', r).catch(handleError)
}
